import { SiteLink } from '@/components/SiteLink';
import { ROUTES } from '@/constants/site';

/** 09. PLAN CTA (도입 유도) */
export function PlanCtaSection() {
  return (
    <section id="cta-plan" aria-labelledby="cta-plan-title" className="bg-white py-20">
      <div className="inner cta-band reveal">
        <img
          src="/assets/icons/pencil.svg"
          alt=""
          aria-hidden="true"
          width="92"
          height="92"
          className="cta-icon"
          loading="lazy"
        />

        <div className="cta-text">
          <p className="section-title">기업 규모를 고려한 맞춤형 플랜으로</p>
          <h2 id="cta-plan-title" className="cta-headline">
            Nova와 함께하세요.
          </h2>
        </div>

        <SiteLink to={ROUTES.plan} className="btn-outline-lg">
          플랜 자세히 보기
        </SiteLink>
      </div>
    </section>
  );
}

/** 10. INQUIRY CTA (문의 섹션) */
export function InquiryCtaSection() {
  return (
    <section
      id="cta-inquiry"
      aria-labelledby="cta-inquiry-title"
      className="bg-surface-deep py-20"
    >
      <div className="inner cta-band reveal">
        <div className="cta-text cta-text-lg">
          <img
            src="/assets/images/logo-nova-white.png"
            alt="Nova"
            width="2272"
            height="657"
            className="cta-logo"
            loading="lazy"
          />
          <h2 id="cta-inquiry-title" className="section-title text-white">
            Nova 솔루션에 대해 더 궁금한 사항이 있으신가요?
          </h2>
        </div>

        <SiteLink to={ROUTES.inquiry} className="btn-ghost-dark">
          문의 바로가기
          <img
            src="/assets/icons/arrow-right-white.svg"
            alt=""
            aria-hidden="true"
            width="28"
            height="28"
            className="h-7 w-7"
          />
        </SiteLink>
      </div>
    </section>
  );
}
